import _brasSizeChartData from './brasSizeChart.json';

type SizeMap = Record<string, string>;

export type CupSize = 'a' | 'b' | 'c' | 'd';

export type BraSizes = Record<CupSize, SizeMap>;

export const brasSizeChartData: BraSizes = _brasSizeChartData;

export const getDropdownOptions = (sizesArray: string[]) => {
  return sizesArray.map((size) => {
    return {
      key: size,
      text: size.toUpperCase(),
      value: size,
    };
  });
};
